import { MedicationDataType, MedicationDataTypeConfig } from './types';

export const MEDICATION_DATA_TYPES: MedicationDataTypeConfig[] = [
  { key: 'problems', label: 'Problems', countKey: 'problems' },
  { key: 'medications', label: 'Medications', countKey: 'medications' },
  { key: 'labResults', label: 'Lab Results', countKey: 'labResults' },
  { key: 'procedures', label: 'Procedures', countKey: 'procedures' },
  { key: 'allergies', label: 'Allergies', countKey: 'allergies' },
  { key: 'vaccinations', label: 'Vaccinations', countKey: 'vaccinations' },
  { key: 'vitals', label: 'Vitals', countKey: 'vitals' },
];

export const DEFAULT_MEDICATION_DATA_TYPE: MedicationDataType = 'problems';
